/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const msisdnConstants = {
    LIST_POOL: 'msisdn_pool_list',
    LIST_POOL_NUMBERS: 'msisdn_pool_list_number',
    LIST_POOL_ITEM: 'msisdn_pool_item',
    LIST_POOL_ITEM_LIST: 'msisdn_pool_item_list',
    LIST_POOL_ADD_NEW: 'msisdn_pool_add_new',
    LIST_POOL_EDIT: 'msisdn_pool_add_edit',
    LIST_POOL_EDIT_SAVE: 'msisdn_pool_add_edit',
    LIST_POOL_NO_ACTION: 'msisdn_pool_no_action',
    LIST_POOL_DELETE: 'msisdn_pool_delete',

    LIST_POOL_NAME_SELECT: 'msisdn_pool_name_select',
    LIST_POOL_NUMBERS_CHOOSE: 'msisdn_pool_numbers_choose',

    ACTIVATE_MSISDN_WITHOUT_BLOCK: 'msisdn_activate_without_block',
};

export class msisdnActions extends defaultActions {
    static getListPool = (url, filter, actionType, callback, options) =>
        defaultActions.getCollection(url, filter, [{ name: 'msisdn', value: 'asc' }], actionType, callback, options);
}
